import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";

const defaultState = {
    checkedRows: [],
    activeAccount: {},
};

const state = {
    ...defaultState
};

const getters = {
    exchangeCheckedRows(state) {
        return state.checkedRows;
    },
    activeAccount(state) {
        return state.activeAccount;
    },
};

const actions = {
    setActionCheckedRowsInExchange({
        commit
    }, payload) {
        commit(types.SET_CHECKED_ROWS_IN_EXCHANGE, payload)
    },
    clearActionCheckedRowsInExchange({
        commit
    }) {
        commit(types.CLEAR_CHECKED_ROWS_IN_EXCHANGE)
    },
    setActionActiveAccount({
        commit
    }, payload) {
        commit(types.SET_ACTIVE_ACCOUNT, payload);
    },
};

const mutations = {
    [types.SET_CHECKED_ROWS_IN_EXCHANGE](state, checkedRows) {
        state.checkedRows = checkedRows;
    },
    [types.CLEAR_CHECKED_ROWS_IN_EXCHANGE](state) {
        state.checkedRows = [];
    },
    [types.SET_ACTIVE_ACCOUNT](state, activeAccount) {
        state.activeAccount = activeAccount;
    },

    initExchangeState(state) {
        resetStoreState(state, defaultState);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};